import { phone } from 'phone';
//Intl is optional and is for the pages that expect the phone to may be invalid
export const formatUserPhoneNumber = ({ phone: phoneNumber, countryDialCode } = {}, intl) => {
  if (!phoneNumber) return '';
  const countryCode = countryDialCode;
  const internationalPhone = `+${countryCode}${phoneNumber}`;

  const result = phone(internationalPhone, {
    strictDetection: true
  });
  if (result.isValid) {
    return internationalPhone;
  } else if (intl) {
    return `${internationalPhone} ${intl.formatMessage({ id: 'phone.is.invalid' })}`;
  } else {
    return internationalPhone;
  }
};

export const removeStartingZero = phoneNumber => {
  if (phoneNumber && phoneNumber[0] === '0') {
    return phoneNumber.slice(1);
  }
  return phoneNumber;
};

//opposite of removeStartingZero
export const formatLocalPhoneNumber = phoneNumber => {
  if (!phoneNumber) return '';

  const str = String(phoneNumber).trim();
  if (str.startsWith('0')) {
    return str;
  }
  return `0${str}`;
};
